import { RISK_ADVISOR_TITLE } from 'Core-utils/constants/constants';
import { FilterCriteria } from '@ampsec/platform-client';
import { useLocation } from 'react-router-dom';
import { AgFindingsGrid } from 'Components/organisms';
import { RootState } from 'Rdx/store';
import { useSelector } from 'react-redux';
import './styles.scss';
import useTimeSpent from 'Hooks/useTimeSpent';
import { useI18n } from 'Hooks/useI18n';

const COMPONENT_IDENTIFIER = 'Security Findings Grid';

const SecurityFindingsPage = () => {
    const { t } = useI18n();
    useTimeSpent(COMPONENT_IDENTIFIER);
    const location = useLocation().state;
    const findingsModel = useSelector((state: RootState) => state.findingsModel);

    const lastIndex = findingsModel.findings.length - 1;
    const defaultFilter = { ...location };
    const filterCriteria = (findingsModel.findings[lastIndex]?.query as FilterCriteria) || {};

    return (
        <div className="d-flex flex-column gap-3 pt-4 pb-4 h-100 security-findings">
            <AgFindingsGrid
                title={t(RISK_ADVISOR_TITLE)}
                filter={filterCriteria}
                defaultFilter={defaultFilter}
                enableUpdatingURLWithFiltersAndSorting={true}
                showSubHeader={false}
            />
        </div>
    );
};

export default SecurityFindingsPage;
